import { FC, PropsWithChildren } from 'react';
import { ApolloProvider } from '@apollo/client';

import { DebugTools } from '@/_app/layouts/DebugTools';
import { AuthProvider } from '@/_app/providers/AuthProvider';
import { CollectionsContainer } from '@/features/collections/CollectionsContainer';
import { SmartImportContainer } from '@/features/smartImport/SmartImportContainer';
import { useAppI18n } from '@/shared/hooks/app/useAppI18n';
import { useInactivityTimer } from '@/shared/hooks/app/useInactivityTimer/useInactivityTimer';
import { NoticesProvider } from '@/shared/providers/notices';
import { useApolloClient } from '@/shared/services/apollo';
import { ModalsContainer } from '@/widgets/modals/ModalsContainer';

import { useAppErrors } from '../hooks/useAppErrors';
import { FormDrawerProvider } from '../providers/FormDrawerProvider';
import { SocketProvider } from '../providers/SocketProvider';
import { ThemeProvider } from '../providers/ThemeProvider';
import { UnsavedChangesProvider } from '../providers/UnsavedChangesProvider';

export const AppContainerCloud: FC<PropsWithChildren> = ({ children }) => {
  const apolloClient = useApolloClient();
  const i18nReady = useAppI18n();

  useAppErrors();
  useInactivityTimer();

  if (!apolloClient) return <div>ApolloClient is not initialized</div>;
  if (!i18nReady) return null;

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider>
        <NoticesProvider>
          <CollectionsContainer />
          <SocketProvider>
            <AuthProvider>
              <FormDrawerProvider>
                <UnsavedChangesProvider>
                  {children}
                  <ModalsContainer />
                  <SmartImportContainer />
                </UnsavedChangesProvider>
              </FormDrawerProvider>
            </AuthProvider>
          </SocketProvider>
        </NoticesProvider>
        <DebugTools />
      </ThemeProvider>
    </ApolloProvider>
  );
};
